var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
import { number, oneOfType, string } from 'prop-types';
import { theme } from '../../Theme';
var Wrapper = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n\n  height: 16px;\n  min-width: 16px;\n\n  padding-right: 5px;\n  padding-left: 5px;\n  margin-left: ", "px;\n\n  color: ", ";\n  font-size: ", "px;\n  line-height: ", "px;\n  font-weight: ", "px;\n\n  border-radius: ", "px;\n  background-color: ", ";\n"])), theme.spacing.xxxsmall, theme.colors.white, theme.fontSizes.xsmall, theme.lineHeights.xsmall, theme.fontWeights.medium, theme.radii.small, theme.colors.primary);

var Counter = function Counter(_ref) {
  var value = _ref.value;
  return /*#__PURE__*/React.createElement(Wrapper, null, Number(value) > 999 ? '+999' : value);
};

Counter.propTypes = {
  value: oneOfType([number, string]).isRequired
};
export default Counter;